import { render, staticRenderFns } from "./shopDrawer.vue?vue&type=template&id=dd3c2b0e&"
import script from "./shopDrawer.vue?vue&type=script&lang=js&"
export * from "./shopDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports